export default __webpack_public_path__ + "static/media/client-01.8265a689.webp";